<template>
  <div class="container">
    <button @click="toggle" class="transparent rows align-items-center width-100p p-15 accordion-button">
      <slot name="title"></slot>
      <span class="ml-auto"></span>
      <span v-if="$slots.actions" class="rows align-items-center">
        <slot name="actions"></slot>
      </span>
      <i class="bi bi-caret-down text-primary ml-10 icon-animation font-size-20" :class="{'icon-active': isExpanded}"></i>
    </button>
    <Collapse :when="isExpanded" class="pl-15 pr-15">
      <slot name="content"></slot>
    </Collapse>
  </div>
</template>

<script>

import { Collapse } from 'vue-collapsed'

export default {
  name: "Accordion",
  components: {Collapse},
  props: {
    expanded: [Boolean, null],
    metadata: [Object, null],
  },
  emits: ['expanded', 'collapsed'],
  data() {
    return {
      isExpanded: this.expanded ?? true,
    }
  },
  methods: {
    toggle() {
      if (this.isExpanded) {
        this.collapse();
      }
      else {
        this.expand();
      }
    },
    expand() {
      this.isExpanded = true;
      this.$emit('expanded');
    },
    collapse() {
      this.isExpanded = false;
      this.$emit('collapsed');
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  border-radius: 30px;
  border: #B650D2 solid 4px;

  .icon-animation {
    transition: all .25s ease-in-out 0s;
  }

  .icon-active {
    transform: rotate(-180deg);
  }
}
</style>